/**
 * Parse coils from a TRCoils string stored in the database.
 * If the string contains commas, splits on commas.
 * Otherwise try to split on delimiters: / + ; and
 */
export const parseCoils = (trCoils: string | undefined): string[] => {
    if (!trCoils) return [];
    const delimiter = trCoils.includes(',')
        ? ','
        : /[;\/+]|\s+and\s+/i;
    return trCoils
        .split(delimiter)
        .map((coil) => coil.trim())
        .filter((coil) => coil.length > 0);
};